export const roomDescriptionConstants = {
    GET_ROOM_DESCRIPTION_PENDING:   'GET_ROOM_DESCRIPTION_PENDING',
    GET_ROOM_DESCRIPTION_FULFILLED:   'GET_ROOM_DESCRIPTION_FULFILLED',
    GET_ROOM_DESCRIPTION_REJECTED:   'GET_ROOM_DESCRIPTION_REJECTED',
};
